import { render, staticRenderFns } from "./down-icon.vue?vue&type=template&id=420d27fc&"
import script from "./down-icon.vue?vue&type=script&lang=js&"
export * from "./down-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports